import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule, ModalController} from '@ionic/angular';
import {LanguageService} from '../../services/language.service';
import {TranslateModule} from '@ngx-translate/core';
import * as flagIcons from '@ng-icons/flag-icons';
import {NgIcon, provideIcons} from "@ng-icons/core";

@Component({
  selector: 'core-select-language-modal',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, NgIcon],
  viewProviders: [provideIcons(flagIcons)],
  templateUrl: './select-language.modal.html',
  styleUrls: ['./select-language.modal.scss']
})
export class SelectLanguageModal {
  protected languageService = inject(LanguageService);
  private modalCtrl = inject(ModalController);

  async close() {
    await this.modalCtrl.dismiss();
  }

  selectLanguage(lang: string) {
    this.languageService.use(lang);
    this.close();
  }

  getCountryCode(langCode: string): string {
    return this.languageService.getCountryCodeForLanguage(langCode);
  }

  getLanguageName(langCode: string): string {
    return this.languageService.getLanguageName(langCode);
  }

  getFlagName(langCode: string): string {
    const country = this.getCountryCode(langCode).toLowerCase();
    return 'flag' + country.charAt(0).toUpperCase() + country.slice(1);
  }
}
